"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var React = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../../../../Layout/Box"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var SVG = function SVG(props) {
  return React.createElement(_Box.default, (0, _tslib.__assign)({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentcolor"
  }, props));
};
var CheckboxChecked = function CheckboxChecked(props) {
  return React.createElement(SVG, (0, _tslib.__assign)({}, props), React.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
};
var CheckboxUnchecked = function CheckboxUnchecked(props) {
  return React.createElement(SVG, (0, _tslib.__assign)({}, props), React.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }));
};
var CheckboxIcon = function CheckboxIcon(props) {
  return React.createElement(React.Fragment, null, React.createElement(CheckboxChecked, (0, _tslib.__assign)({}, props, {
    __css: {
      display: 'none',
      // tslint:disable-next-line:no-duplicate-string
      'input:checked ~ &': {
        display: 'block'
      }
    }
  })), React.createElement(CheckboxUnchecked, (0, _tslib.__assign)({}, props, {
    __css: {
      display: 'block',
      'input:checked ~ &': {
        display: 'none'
      }
    }
  })));
}; // TODO: Margin, padding bg, color being applied to wrong element (input instead of checkbox icon)

var Checkbox = React.forwardRef(function (_a, ref) {
  var field = _a.field,
    sx = _a.sx,
    _b = _a.variant,
    variant = _b === void 0 ? 'forms.checkbox' : _b,
    props = (0, _tslib.__rest)(_a, ["field", "sx", "variant"]);
  return React.createElement(_Box.default, {
    sx: {
      position: 'relative',
      '::focus-within': {
        outline: '1px dotted',
        outlineColor: 'slategrey'
      }
    }
  }, React.createElement(_Box.default, (0, _tslib.__assign)({
    ref: ref,
    as: "input"
  }, props, field, {
    type: "checkbox",
    checked: field && field.value,
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: 1,
      width: '24px',
      height: '24px',
      overflow: 'hidden'
    }
  })), React.createElement(_Box.default, {
    as: CheckboxIcon,
    "aria-hidden": "true",
    variant: variant,
    sx: sx,
    __css: {
      mr: 2,
      borderRadius: 4,
      cursor: 'pointer',
      color: 'highlight',
      'input:checked ~ &': {
        color: 'primary'
      },
      'input:focus ~ &': {
        color: 'primary'
      }
    }
  }));
});
var CheckboxInput = function CheckboxInput(_a) {
  var defaultChecked = _a.defaultChecked,
    field = _a.field,
    hint = _a.hint,
    id = _a.id,
    label = _a.label,
    name = _a.name,
    value = _a.value,
    props = (0, _tslib.__rest)(_a, ["defaultChecked", "field", "hint", "id", "label", "name", "value"]);
  return React.createElement(Checkbox, (0, _tslib.__assign)({
    defaultChecked: defaultChecked,
    id: id,
    field: field,
    name: field && field.name || name,
    value: field && field.value || value || id
  }, props));
};
CheckboxInput.displayName = 'CheckboxInput';
CheckboxInput.defaultProps = {
  defaultChecked: false
};
var _default = CheckboxInput;
exports.default = _default;